import styled from 'styled-components';

export const Layout = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`
export const HeaderLayout = styled.div`
    flex : 0 1 auto;
    height: calc(100vw*(51/375));
    min-height: calc(100vw*(51/375));
`
export const BodyLayout = styled.div`
    flex: 1 1 auto;
    height: 100%;
`